import { Injectable } from "@angular/core";
import * as moment from "moment";

@Injectable()
export class MomentLocaleService {
    setLocaleFromBrowser() {
        moment.locale("pt-BR");
    }
}
